"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export default function Coverage() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="coverage" data-nav="light" className="bg-background py-14 md:py-20 lg:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="flex flex-col items-center">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Coverage
          </span>

          <h2 className="mt-3 font-default text-2xl font-bold tracking-tight text-foreground sm:text-3xl md:text-4xl">
            Service Area
          </h2>

          <p className="mt-4 text-base leading-relaxed text-muted-foreground md:text-lg">
            Fridge Fleet serves Southern California and Southern Nevada. Delivery coverage and availability depend on the specific location and rental dates.
          </p>
        </motion.div>
      </div>
    </section>;
}